import { render, staticRenderFns } from "./TransformOriginTool.vue?vue&type=template&id=5871b222&"
import script from "./TransformOriginTool.vue?vue&type=script&lang=js&"
export * from "./TransformOriginTool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports